import { render, staticRenderFns } from "./block-header.vue?vue&type=template&id=7e147898&"
import script from "./block-header.vue?vue&type=script&lang=js&"
export * from "./block-header.vue?vue&type=script&lang=js&"
import style0 from "./block-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports